export default class MasterAssessorList {
    constructor({ id: id, regNumber: regNumber, fullName: name, siteShortName: siteCode, mobile: phone, email: email, gender: gender, schemes: schemes }) {
        this.id = id;
        this.regNumber = regNumber;
        this.fullName = name;
        this.siteShortName = siteCode;
        this.mobile = phone;
        this.email = email;
        this.gender = gender;
        this.schemes = schemes;
    }
}
